<template>
  <div class="upload-file">
    <template v-if="currentImage">
      <div
        class="text-center preview-img"
        style="overflow:hidden;height:150px;background-position: center;background-repeat: no-repeat;background-size: cover;"
        :style="{ height : height + 'px', 'background-image' : 'url(\''+currentImage+'\')'}"
      >
        <video
          v-if="currentImage.includes('.mp4')"
          width="100%"
          height="100%"
          autoplay
          muted
          loop
          poster="/static/img/assets/loading.gif"
          preload="auto"
        >
          <source :src="currentImage" type="video/mp4" />
        </video>
        <div class="overlay">
          <div
            class="text-xs-center"
            style="position:absolute;top: 50%;width: 100%;margin-top:-26px;"
          >
            <v-btn
              small
              depressed
              color="primary"
              @click="onClickUploadButton"
              style="font-size: 11px"
            >
              <span class="fa fa-camera mr-1"></span>
              {{$t('select file to upload')}}
            </v-btn>

            <div
              class="caption"
              style="color: white"
            >{{$t('upload file size: {size}MB',{'size': 5})}}</div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="text-xs-center">
        <div
          style="height:150px;background:#eee;overflow:hidden;position:relative"
          :style="{ height : height + 'px'}"
        >
          <template v-if="loading">
            <div style="position:absolute;top: 50%;left:50%;margin-top:-15px;margin-left:-21px">
              <!-- <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader> -->
              <v-progress-circular
                :rotate="-90"
                :size="60"
                :width="5"
                :value="$store.state.progress"
                color="primary"
              >{{ parseInt($store.state.progress) }}%</v-progress-circular>
            </div>
          </template>
          <template v-else>
            <div
              class="text-xs-center"
              style="position:absolute;top: 50%;width: 100%;margin-top:-26px;"
            >
              <v-btn
                small
                depressed
                color="primary"
                @click="onClickUploadButton"
                style="font-size: 11px"
              >
                <span class="fa fa-camera mr-1"></span>
                {{$t('select file to upload')}}
              </v-btn>

              <div class="caption grey--text">{{$t('upload file size: {size}MB',{'size': 10})}}</div>
            </div>
          </template>
        </div>
      </div>
    </template>

    <input
      type="file"
      class="form-control-file pt-2"
      name="photoUpload"
      :id="'photoUploadInput' + objId"
      data-vv-as="File"
      @change="onFileChange($event)"
      style="overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;"
    />
    <!-- v-validate="'image|size:10240|mimes:image/jpeg,image/png,image/jpg,image/gif'"
    accept=".jpg, .png, .jpeg, .gif"-->
  </div>
</template>
<script>
import api from '@/api'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

export default {
  props: {
    value: null,
    height: {
      default: 250,
      type: Number
    }
  },
  data: function() {
    return {
      currentImage: this.value,
      loading: false,
      objId: null
    }
  },
  components: {
    SyncLoader
  },
  created: function() {
    // if (!this.height || this.height === 'undefined') {
    // 	this.height = 250
    // }
    this.objId = Math.random()
  },
  methods: {
    onClickUploadButton: function() {
      document.getElementById('photoUploadInput' + this.objId).click()
    },
    fileResize: function(file, callback) {
      let vm = this
      var reader = new FileReader()
      reader.onloadend = function() {
        var tempImg = new Image()
        tempImg.src = reader.result
        tempImg.onload = function() {
          var MAX_WIDTH = 1000
          var MAX_HEIGHT = 1000
          var tempW = tempImg.width
          var tempH = tempImg.height
          if (tempW > tempH) {
            if (tempW > MAX_WIDTH) {
              tempH *= MAX_WIDTH / tempW
              tempW = MAX_WIDTH
            }
          } else {
            if (tempH > MAX_HEIGHT) {
              tempW *= MAX_HEIGHT / tempH
              tempH = MAX_HEIGHT
            }
          }

          var canvas = document.createElement('canvas')
          canvas.width = tempW
          canvas.height = tempH
          var ctx = canvas.getContext('2d')
          ctx.drawImage(this, 0, 0, tempW, tempH)
          var dataURL = canvas.toDataURL('image/jpeg')
          var data = 'image=' + dataURL
          var obj = vm.dataURItoBlob(data)
          obj.name = file.name
          callback(obj)
        }
      }
      reader.readAsDataURL(file)
    },
    dataURItoBlob: function(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    onFileChange: function(event) {
      let vm = this

      vm.loading = true
      let files = event.target.files || event.dataTransfer.files
      if (!files.length) return
      if (files[0].type == 'image/gif' || files[0].type == 'video/mp4') {
        vm.createImage(files[0])
      } else {
        vm.fileResize(files[0], function(obj) {
          vm.createImage(obj)
        })
      }
      event.target.value = ''
    },
    createImage(file) {
      let reader = new FileReader()
      let vm = this
      // reader.onload = (e) => {
      //     vm.image = e.target.result
      // }
      // reader.readAsDataURL(file)
      vm.upload(file)
    },
    upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file
      }
      let vm = this
      vm.currentImage = ''
      api.getSignedRequest(data, function(error, url) {
        if (error) {
          console.error(error)
          vm.loading = false
          return
        }

        url = encodeURI(url)

        vm.currentImage = url
        vm.$emit('input', vm.currentImage)
        vm.loading = false
        vm.$emit('onUploaded', vm.currentImage)
      })
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.currentImage = newVal
    }
  }
}
</script>

<style>


// WEBPACK FOOTER //
// src/components/elements/uploadvideo.vue